export const analytics = {
  title: "Analíticas",
  subtitle: "Ingresos y ocupación de tus propiedades en el periodo que elijas.",
  tabs: {
    performance: "Desempeño",
    channels: "Canales",
  },
  allAccommodations: "Todos los alojamientos",
  compare: {
    prevPeriod: "Último período",
    prevYear: "Año anterior",
    titlePrevPeriod: "Comparación: último período",
    titlePrevYear: "Comparación: año anterior",
    inlinePrevPeriod: "último período",
    inlinePrevYear: "año anterior",
  },
  summary: {
    currentPeriod: "Período actual",
    paymentFilter: "Filtro de pago",
  },
  presets: {
    today: "Hoy",
    yesterday: "Ayer",
    d7: "7 días",
    d30: "30 días",
    m3: "3 meses",
    m6: "6 meses",
    year: "1 año",
  },
  payment: {
    all: "Todos los pagos",
    pending: "Pendientes",
    paid: "Pagadas",
    rejected: "Rechazadas",
    refunded: "Reembolsadas",
    partial: "Pago parcial",
  },
  kpi: {
    totalRevenue: "Ingreso del período",
    arrivalRevenue: "Valor total llegadas",
    revpar: "RevPAR",
    occupancyRate: "Tasa de ocupación",
    adr: "ADR",
    avgStay: "Duración media",
    bookingWindow: "Ventana reserva",
  },
  units: {
    days: " días",
  },
  chart: {
    thisPeriod: "Este período",
    subtitle: "{current} · comparado con {compared} · {payment}",
  },
  channels: {
    directBookings: "Reservas directas",
    otaBookings: "Reservas OTA",
    bookingDetails: "Detalles de la reserva",
    byChannel: "Por canal",
    tableChannel: "Canal",
    tableRevenue: "Ingresos",
    direct: "Directas",
    ota: "OTA",
    noData: "Sin datos para el período seleccionado",
  },
  a11y: {
    chartOf: "Gráfica de {label}",
    directVsOta: "Gráfica de reservas directas vs OTA",
  },
};
